module.exports = __webpack_public_path__ + "assets/img/100211.addf82c5.png";